import React from 'react';

import { SortableTable } from '~/components/core';
import Chip from '~/components/core/Atomic/Chip/Chip';
import { PencilIcon } from '~/components/icons';
import InlineIconButton from '~/components/InlineIconButton';
import { getAmericanDateFormat } from '~/DateTimeUtils';
import type { N8NConfigurationModel } from '~/server_shared/openapi/data-contracts';

interface N8nConfigurationCardProps {
  configuration: N8NConfigurationModel;
  onEdit: () => void;
  isLoading: boolean;
}

const N8nConfigurationCard: React.FC<N8nConfigurationCardProps> = ({ configuration, onEdit, isLoading }) => {
  const formatDate = (dateString?: string) => {
    if (!dateString) return 'N/A';
    return getAmericanDateFormat(dateString);
  };

  // Use the configuration directly as table data
  const tableData: N8NConfigurationModel[] = [configuration];

  const columnData = [
    { id: 'id', isHidden: true },
    {
      id: 'is_enabled',
      label: 'Status',
      specialCell: (row: N8NConfigurationModel) => (
        <Chip
          label={row.is_enabled ? 'Enabled' : 'Disabled'}
          color={row.is_enabled ? 'primary' : 'default'}
          size="small"
        />
      ),
    },
    {
      id: 'timeout_seconds',
      label: 'Timeout',
      specialCell: (row: N8NConfigurationModel) => `${row.timeout_seconds} seconds`,
    },
    {
      id: 'created_datetime',
      label: 'Created',
      specialCell: (row: N8NConfigurationModel) => formatDate(row.created_datetime),
    },
    {
      id: 'last_updated_datetime',
      label: 'Last Updated',
      specialCell: (row: N8NConfigurationModel) => (
        <div>
          <div>{formatDate(row.last_updated_datetime)}</div>
          {row.last_updated_by_username && (
            <div className="text-gray-500 text-sm">by {row.last_updated_by_username}</div>
          )}
        </div>
      ),
    },
    {
      id: 'actions',
      label: 'Actions',
      disableSort: true,
      specialCell: () => (
        <div className="flex items-center gap-2">
          <InlineIconButton
            tooltipTitle="Edit"
            icon={PencilIcon}
            className="cursor-pointer hover:stroke-teal-700"
            onClick={onEdit}
            disabled={isLoading}
          />
        </div>
      ),
    },
  ];

  return <SortableTable defaultOrderColumn={0} columns={columnData} rows={tableData} hideHeader={false} />;
};

export default N8nConfigurationCard;
